import {
	createRouter,
	createWebHistory,
	createWebHashHistory,
} from "vue-router";
import createImg from "../components/createImg.vue";

const router = createRouter({
	routes: [{
			path: "/",
			component: () => import("../components/createImg.vue")
		}, {
			path: "/createImg",
			component: () => import("../components/createImg.vue")
		},
		{
			path: "/compressImg",
			component: () => import('../components/compressImg.vue')
		},
		{
			path: "/changeImg",
			component: () => import('../components/changeImg.vue')
		},
		{
			path: "/imgToBase64",
			component: () => import('../components/imgToBase64.vue')
		},
		{
			path: "/qrCode",
			component: () => import('../components/qrCode.vue')
		},
		{
			path: "/cropImg",
			component: () => import('../components/cropImg.vue')
		},
	],
	history: createWebHashHistory(),
});
export default router;